// extracted by mini-css-extract-plugin
export var dropdown = "_re-0";
export var imageWrapper = "_re-3";
export var itemNameContainer = "_re-1";
export var productImage = "_re-2";
export var spinnerWrapper = "_re-4";